import { Input } from "antd";
import type { InputProps } from "antd";

export default function AppInput({ placeholder, suffix, ...rest }: InputProps) {
  const resolvedSuffix =
    suffix !== undefined
      ? suffix
      : placeholder
      ? (
          <span
            style={{ color: "#bfbfbf", fontSize: 12, pointerEvents: "none", userSelect: "none" }}
          >
            {placeholder}
          </span>
        )
      : undefined;

  return <Input placeholder={placeholder} suffix={resolvedSuffix} {...rest} />;
}
